var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCloseModal(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8818 18.0892C17.7705 18.0892 17.6589 18.0468 17.5737 17.9619L8.30849 8.72285C8.13817 8.55282 8.13758 8.2767 8.30762 8.10637C8.47736 7.93605 8.75348 7.93547 8.92439 8.1055L18.1899 17.3446C18.3602 17.5146 18.3608 17.7907 18.1908 17.961C18.1056 18.0465 17.9937 18.0892 17.8818 18.0892Z",
    fill: "white",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.61659 18.0892C8.50468 18.0892 8.39278 18.0465 8.30762 17.961C8.13758 17.7907 8.13817 17.5146 8.30849 17.3446L17.574 8.1055C17.7449 7.93547 18.021 7.93605 18.1908 8.10637C18.3608 8.2767 18.3602 8.55282 18.1899 8.72285L8.92468 17.9619C8.83952 18.0468 8.72791 18.0892 8.61659 18.0892Z",
    fill: "white",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 25.0001C6.38323 25.0001 1 19.6169 1 13.0001C1 6.38337 6.38323 0.999847 13 0.999847C19.6168 0.999847 25 6.38308 25 13.0001C25 19.6172 19.6171 25.0001 13 25.0001ZM13 1.87181C6.86397 1.87181 1.87197 6.86382 1.87197 13.0001C1.87197 19.1365 6.86397 24.1282 13 24.1282C19.136 24.1282 24.128 19.1362 24.128 12.9998C24.128 6.86353 19.136 1.87181 13 1.87181Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseModal);
export default __webpack_public_path__ + "static/media/close_modal.9fa0b3a199203f910fa4f15860c53066.svg";
export { ForwardRef as ReactComponent };